<template>
  <div>
    <baseFrame
      saveText="保存"
      submitText="提交"
      clearText=""
      @save="addStocktakingResults"
      @submit="submitStocktakingResults"
      @cancel="handleToStocktakingPlan"
      :saveLoading="saveLoading"
      :submitLoading="submitLoading"
      :showCtrls="true"
      :infosArr="infosArr"
      :id="stocktakingPlan.serialNumber"
      idText="盘点单号">
      <div slot="content">
        <lk-card title="">
          <div style="display:flex;align-items:center;">
            <div>商品搜索:</div>
            <lk-input style="width: 300px;margin-left:10px;" placeholder='支持商品编码、通用名、商品名' v-model="searchContent"></lk-input>
            <div style="margin-left:20px">
              <lk-button type='primary' @click="handleSearch">查询</lk-button>
              <lk-button style="margin-left:10px;" @click="handleReset">重置</lk-button>
            </div>
          </div>
        </lk-card>
        <lk-card title="盘点结果信息">
          <div class="requireStocktakingRecord">
            <dtp-table class="mb16" border :columns="columns" :data="tableData"></dtp-table>
            <div class="mb16" style="text-align:right">
              <lk-page
                :total="count"
                :current="page"
                :page-size="size"
                :page-size-opts="[50]"
                size="small"
                show-elevator
                show-total
                transfer
                @on-change="handlePage">
              </lk-page>
            </div>
          </div>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import DtpTable from '../../components/DtpTable';
import sharedData from '../../libs/sharedDara';

export default {
  components: {
    baseFrame,
    DtpTable,
  },
  data() {
    return {
      searchContent: null,
      saveLoading: false,
      submitLoading: false,
      infosArr: [],
      stocktakingPlan: {},
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      boolsMap: new Map([
        [1, '是'],
        [2, '否'],
      ]),
      columns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + (this.page - 1) * this.size + 1),
        },
        { title: '通用名首字母', key: 'initial', minWidth: 110 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '系统冻结数量', key: 'breakageFrozenAmount', minWidth: 110 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 110 },
        { title: '可销售数量', key: 'inventoryCount', minWidth: 110 },
        { title: '在库数量', key: 'inInventoryCount', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '商品状态', key: 'goodsStoreStatusStr', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        {
          title: '实盘数量',
          key: 'realCount',
          minWidth: 130,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input-number', {
            props: {
              value: row.realCount,
              min: 0,
              max: 9999999.99,
              precision: 2,
              activeChange: false,
            },
            on: {
              'on-change': (value) => {
                // 库存数量+库存冻结数量+销售订单占用+不合格数量 == 实盘数量是否相等
                this.changedData.push({ id: row.id, value});
                const realCount = row.breakageFrozenAmount + row.manualFrozenNum + row.inventoryCount;
                const hasDiff = realCount === value ? 2 : 1;
                row.hasDiff = hasDiff;
                row.hasDiffStr = this.boolsMap.get(hasDiff);
                row.realCount = value;
              },
            },
          }),
        },
        {
          title: '存在差异', key: 'hasDiffStr', minWidth: 110, fixed: 'right',
        },
        { title: '盘点人员', key: 'operatorName', minWidth: 110, fixed: 'right' },
      ],
      tableData: [],
      tableDataAll: [],
      searchData: [],
      changedData: [], // 记录改动的哪些数据，id和实盘数量值.
      copedData: [], // tableDataAll的副本数据，是最初始的从后端获取的数据
      page: 1,
      size: 50,
      count: 0,
      lastPage: 1,
    };
  },
  computed: {},
  methods: {
    handleSearch() {
      this.toUpdateTableData();
      this.searchData = [];
      this.page = 1;
      if (this.searchContent && this.searchContent !== 0) {
        this.tableDataAll.forEach(item => {
          if (item.drugSerialCode.indexOf(this.searchContent) !== -1 || item.goodsName.indexOf(this.searchContent) !== -1 || item.approvedDrugNames.indexOf(this.searchContent) !== -1) {
            this.searchData.push(item);
          }
        })
        this.count = this.searchData.length;
        this.getPageData(1, this.searchData);
      } else {
        this.searchData = this.tableDataAll;
        this.count = this.tableDataAll.length;
        this.getPageData(1, this.searchData);
      }
    },
    getPageData(val, searchData) {
      let pageData = [];
      if (searchData) {
        const currentNum = (val - 1) * this.size; // 起始数据
        pageData = this.searchData.slice(currentNum, currentNum + this.size);
      } else {
        const currentNum = (val - 1) * this.size; // 起始数据
        pageData = this.tableDataAll.slice(currentNum, currentNum + this.size);
      }
      this.tableData = pageData;
    },
    handleReset() {
      this.searchContent = null;
    },
    getData() {
      const params = {
        stocktakingPlanId: Number.parseInt(this.$route.params.id, 10),
        menuSourceType: 2,
        nameMix: this.searchContent,
        storeIdList: [this.$store.state.storeInfo.id],
        status: this.$route.params.status,
      }
      inventory.stocktakingRecordList(params)
        .then((res) => {
          if (res.data.status === 200) {
            const { stocktakingPlan, stocktakingRecords } = res.data.data;
            if (stocktakingPlan && stocktakingPlan.operatorPattern) {
              if (stocktakingPlan.operatorPattern === 2) {
                const newColumns = [];
                const list = ['breakageFrozenAmount', 'manualFrozenNum', 'inventoryCount', 'inInventoryCount', 'hasDiffStr'];
                this.columns.forEach((item, index) => {
                  if (!list.includes(item.key)) {
                    newColumns.push(item);
                  }
                })
                this.columns = newColumns;
              }
            }
            if (!([2, 4].includes(stocktakingPlan.status))) { // 非待完成的状态，不可录入
              this.$Message.error('该盘点计划不能录入');
              setTimeout(() => {
                this.handleToStocktakingPlan();
              }, 1000);
              return;
            }
            stocktakingRecords.forEach((item) => {
              item.stocktakingRecordId = item.id;
              item.goodsStoreStatusStr = this.statusMap.get(item.goodsStoreStatus);
              item.hasDiffStr = this.boolsMap.get(item.hasDiff);
            });
            this.setInfoArr(stocktakingPlan);
            this.stocktakingPlan = stocktakingPlan;
            this.tableDataAll = stocktakingRecords;
            this.count = this.tableDataAll.length;
            this.getPageData(1); // 获取分页数据
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
    },
    setInfoArr(stocktakingPlan) {
      if (!stocktakingPlan) {
        return;
      }
      stocktakingPlan.hasZeroStr = this.boolsMap.get(stocktakingPlan.hasZero);
      stocktakingPlan.createTime = utils.exchangeTime(stocktakingPlan.createTime);
      stocktakingPlan.operatorTime = utils.exchangeTimeToSecond(stocktakingPlan.operatorTime);
      stocktakingPlan.operatorType = sharedData.operatorTypeList[stocktakingPlan.operatorType - 1].name;
      stocktakingPlan.operatorPattern = sharedData.operatorPatternsList[stocktakingPlan.operatorPattern - 1].name;
      if (!stocktakingPlan.warehouseNames) {
        stocktakingPlan.warehouseNames = '全部';
      }

      const infosArr = [
        {
          name: '盘点计划名称:',
          value: stocktakingPlan.name,
        },
        {
          name: '盘点类型:',
          value: stocktakingPlan.operatorType,
        },
        {
          name: '盘点方式:',
          value: stocktakingPlan.operatorPattern,
        },
        {
          name: '是否含0在库数量商品:',
          value: stocktakingPlan.hasZeroStr,
        },
        {
          name: '盘点仓库:',
          value: stocktakingPlan.warehouseNames,
        },
        {
          name: '创建人员:',
          value: stocktakingPlan.createUserName,
        },
        {
          name: '创建时间:',
          value: stocktakingPlan.createTime,
        },
        {
          name: '盘点人员:',
          value: stocktakingPlan.allOperatorName,
        },
        {
          name: '盘点时间:',
          value: stocktakingPlan.operatorTime,
        },
      ];
      this.infosArr = infosArr;
    },
    getStocktakingResults() {
      this.toUpdateTableData();
      let errorMsg = '';
      let invalidList = []; //记录所有不合格的数据在第几行，便于提示信息展示。
      const stocktakingResults = [];
      for (let i = 0, len = this.tableDataAll.length; i < len; i++) {
        if (this.tableDataAll[i].realCount === null) {
          errorMsg = '实盘数量不能是空';
          invalidList.push((i+1));
          break;
        }
        if (Number.isNaN(Number(this.tableDataAll[i].realCount))) {
          errorMsg = '实盘数量必须为数字';
          break;
        }
        if (Number(this.tableDataAll[i].realCount) < 0) {
          errorMsg = '实盘数量不能为负数';
          invalidList.push((i+1));
          break;
        }
        stocktakingResults.push({
          stocktakingRecordId: this.tableDataAll[i].stocktakingRecordId,
          realCount: this.tableDataAll[i].realCount,
          breakageFrozenAmount: this.tableDataAll[i].breakageFrozenAmount,
          saleFrozenAmount: this.tableDataAll[i].saleFrozenAmount,
        });
      }
      if (errorMsg) {
        this.$Message.error(`${errorMsg}, 请修改第${invalidList}行`);
        return false;
      }
      return stocktakingResults;
    },
    addStocktakingResults() {
      const stocktakingResults = this.getStocktakingResults();
      if (!stocktakingResults) {
        return;
      }
      this.saveLoading = true;
      inventory.addStocktakingResults({
        stocktakingResults,
        stocktakingPlanId: Number.parseInt(this.$route.params.id),
        status: this.$route.params.status
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('保存成功');
          } else {
            this.$Message.error(res.data.error);
          }
          this.saveLoading = false;
        })
        .catch((err) => {
          this.saveLoading = false;
          utils.handleError(err);
        });
    },
    submitStocktakingResults() {
      const stocktakingResults = this.getStocktakingResults();
      if (!stocktakingResults) {
        return;
      }
      this.submitLoading = true;
      inventory.submitStocktakingResult({
        stocktakingResults,
        stocktakingPlanId: Number.parseInt(this.$route.params.id, 10),
        status: this.$route.params.status
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('提交成功');
            this.handleToStocktakingPlan();
          } else {
            this.$Message.error(res.data.error);
          }
          this.submitLoading = false;
        })
        .catch((err) => {
          this.submitLoading = false;
          utils.handleError(err);
        });
    },
    handleToStocktakingPlan() {
      this.$router.push({
        name: 'stocktakingPlan',
      });
    },
    // 切换页面
    handlePage(val) {
      this.toUpdateTableData();
      this.page = val;
      if (this.searchData.length) {
        this.getPageData(val, this.searchData);
      } else {
        this.getPageData(val);
      }
    },
    toUpdateTableData() {
      if (!this.changedData.length) {
        return
      }
      this.changedData.forEach(item => {
        let obj = this.tableDataAll.find(dataItem => item.id === dataItem.id);
        obj.realCount = item.value;
      })
      this.changedData = [];
    }
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>